import api from "../../../services/axiosInstance";

export default api;
